import React from 'react';
import { Button } from './primitives';
import { SCENE_IMG } from '../media';
export function Hero() {
  return <section id="top" className="bg-background" aria-labelledby="hero-heading" data-id="element-45" data-mp="eiv62y7sfcld">
      <div className="section-shell grid items-center gap-10 py-12 lg:grid-cols-[1fr_1.05fr] lg:gap-16 lg:py-16" data-id="element-46" data-mp="9ka68zwg6uxg">
        <div data-id="element-47" data-mp="4mrvd3yve5mt">
          <p className="overline" data-id="element-48" data-mp="4n1oh0f7oswq">Vitality Foundation</p>
          <h1 id="hero-heading" className="mt-5 font-serif text-h2 leading-[1.02] lg:text-h1" data-id="element-49" data-mp="1297ba1bnev89">
            Basecamp for founders building from nature.
          </h1>
          <p className="mt-6 max-w-lg text-body leading-body text-muted-foreground lg:text-body-lg" data-id="element-50" data-mp="x8b7dnrar92u">
            Turning a nature-inspired breakthrough into a company is an expedition into unknown
            terrain. We&rsquo;re your crew: the mentors, experts, and support you need for the next
            stretch.
          </p>
          <div className="mt-8 flex flex-wrap gap-3" data-id="element-51" data-mp="382p55bt4dbkm">
            <Button href="#founders-door" data-id="element-52" data-mp="3814a7l2w7qm8">I&rsquo;m a founder</Button>
            <Button href="#mentors-door" variant="outline" data-id="element-53" data-mp="3j9kbrdwi3lh6">
              I want to mentor
            </Button>
          </div>
        </div>

        <figure className="m-0 overflow-hidden rounded-lg" data-id="element-54" data-mp="3o5j2h85axfkr">
          <img src={SCENE_IMG.windRiverLake} alt="Granite peaks reflected in a still alpine lake" className="block aspect-[4/3] w-full object-cover" data-id="element-55" data-mp="399bcfr77pjxk" />
        </figure>
      </div>
    </section>;
}